import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';
import { error } from '@pressreader/logger';
import { isViewName, selectNavConfig } from '@pressreader/navigation-core';
import { ViewName } from '@pressreader/navigation-types';

// the config value is a string in the following format "viewName1,viewName2,viewName3..."
const viewNamesShowMenuFontsConfigKey = 'UI.TopToolbar.MenuRight.Items.Fonts.AllowedOnViews';
// default views where the Fonts menu item is shown if the config is not set
const viewNamesShowMenuOnFallback = Object.freeze([ViewName.Article, ViewName.FTSArticles, ViewName.TextView, ViewName.TopNews]);

const selectShowMenuFontsOnViews = createSelector(selectGetConfigValue, getConfigValue => {
    const viewNamesAllowedOnCommaSeparated = getConfigValue<string>(viewNamesShowMenuFontsConfigKey);
    const viewNamesShowMenuOn =
        typeof viewNamesAllowedOnCommaSeparated === 'string' ? viewNamesAllowedOnCommaSeparated.split(',') : viewNamesShowMenuOnFallback;

    return viewNamesShowMenuOn.filter(viewName => {
        const viewNameTrimmedLowered = viewName.trim().toLowerCase();
        if (!isViewName(viewNameTrimmedLowered)) {
            error(new Error(`Invalid view name "${viewName}" found in "UI.TopToolbar.MenuRight.Items.Fonts.AllowedOnViews" configuration.`));
            return false;
        }
        return true;
    });
});

export const selectShowMenuFonts = createSelector(selectNavConfig, selectShowMenuFontsOnViews, (navConfig, showMenuFontsOnViews) =>
    showMenuFontsOnViews.some(w => w === navConfig?.viewName),
);
